import { useState } from "react";
import { api } from "@/lib/api";
import { GripVertical } from "lucide-react";

// Admin view of a single group's ranking with drag-to-reorder (manual override).
export default function GroupStandings({ group, data }) {
  const rows = data?.rows || [];
  const [dragIdx, setDragIdx] = useState(null);

  const persist = async (names) => {
    await api.put(`/groups/${group.id}`, { manual_order: names });
  };

  const onDrop = (to) => {
    if (dragIdx === null || dragIdx === to) return;
    const names = rows.map((r) => r.name);
    const [x] = names.splice(dragIdx, 1);
    names.splice(to, 0, x);
    setDragIdx(null);
    persist(names);
  };

  return (
    <div className="bg-[#0A0C10] border border-[#1E2638] rounded-xl p-4" data-testid={`group-standings-${group.id}`}>
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-display font-bold uppercase tracking-wide text-[#00F0FF]">{group.name}</h3>
        {data?.complete ? (
          <span className="text-[10px] uppercase tracking-widest text-[#E5FF00] border border-[#E5FF00]/40 rounded px-2 py-0.5">Komplett</span>
        ) : (
          <span className="text-[10px] uppercase tracking-widest text-[#8A99AD]">läuft</span>
        )}
      </div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[#8A99AD] font-display uppercase text-xs">
            <th className="w-6"></th>
            <th className="w-6 text-left">#</th>
            <th className="text-left">Mannschaft</th>
            <th className="w-8 text-center">Sp</th>
            <th className="w-12 text-center">Tore</th>
            <th className="w-10 text-center">Diff</th>
            <th className="w-10 text-center">Pkt</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr
              key={r.name}
              draggable
              onDragStart={() => setDragIdx(i)}
              onDragOver={(e) => e.preventDefault()}
              onDrop={() => onDrop(i)}
              className={`border-t border-[#1E2638] ${dragIdx === i ? "opacity-40" : ""}`}
              data-testid={`group-row-${group.id}-${i}`}
            >
              <td className="text-[#3a465e] cursor-grab active:cursor-grabbing"><GripVertical className="w-4 h-4" /></td>
              <td className="text-[#E5FF00] font-bold">{i + 1}</td>
              <td className="font-display font-bold py-1.5">{r.name}</td>
              <td className="text-center font-mono-num">{r.sp}</td>
              <td className="text-center font-mono-num">{r.tore}</td>
              <td className="text-center font-mono-num">{r.diff}</td>
              <td className="text-center font-mono-num text-[#00F0FF] font-bold">{r.pkt}</td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={7} className="text-[#3a465e] text-xs py-2">Noch keine Spiele in dieser Gruppe.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
